import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import get from 'lodash/get'

import { Loading } from '@fielded/shared-ui'

import { selectMasterData } from '../../../../root/reducers/shipments/master-data'
import { isReturnShipment } from '../../../../common/utils/shipment'
import { getPlannedQuantities, makeDeliveryItems } from '../../common/makeDeliveryItems'
import PSMDeliveryConfirmation from './PSMDeliveryConfirmation'

const PSMDeliveryConfirmationContainer = ({
  api,
  user,
  config,
  shipment,
  formRef,
  comment,
  onCommentChange,
  onProceedClick
}) => {
  const masterData = useSelector(selectMasterData)

  const [location, setLocation] = useState()
  const [items, setItems] = useState([])
  const [name, setName] = useState('')
  const [signature, setSignature] = useState('')
  const [loading, setLoading] = useState(true)

  const productsById = get(masterData, 'products.byId', {})

  let locationId = get(shipment, 'destination.id')
  if (isReturnShipment(null, shipment)) {
    locationId = get(shipment, 'origin.id')
  }

  const fetchData = async () => {
    try {
      let location = await api.location.get(locationId)
      if (!location) {
        // fetch from agave
        const locations = await api.location.getLocationsViaIds([locationId])
        location = locations[0]
      }
      const plannedQuantities = getPlannedQuantities(shipment)
      const items = makeDeliveryItems({ shipment, productsById, plannedQuantities, config }) || []
      setLocation(location)
      setItems(items)
    } catch (error) {
      console.warn(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  if (loading) {
    return <Loading loadingText='Loading delivery note …' />
  }

  return (
    <PSMDeliveryConfirmation
      config={config}
      formRef={formRef}
      shipment={shipment}
      location={location}
      items={items}
      name={name}
      signature={signature}
      comment={comment}
      onCommentChange={onCommentChange}
      onProceed={onProceedClick}
      setName={setName}
      setSignature={setSignature}
    />
  )
}

export default PSMDeliveryConfirmationContainer
